import clsx from "clsx";
import type { ComponentPropsWithoutRef, ReactNode, Ref } from "react";
import {
	type SyncStatusPresentation,
	syncStatusToneClassName,
} from "./syncStatusPresentation.ts";

type Props = Omit<ComponentPropsWithoutRef<"span">, "children"> & {
	status: SyncStatusPresentation;
	iconPosition: "leading" | "trailing";
	children: ReactNode;
	ref?: Ref<HTMLSpanElement> | undefined;
};

export const SyncStatusText = ({
	status,
	iconPosition,
	children,
	className,
	ref,
	...rest
}: Props) => {
	const { Icon } = status;
	const icon = (
		<Icon
			size={16}
			stroke={1.5}
			className={clsx(
				"shrink-0",
				status.spin === "smooth" && "animate-spin",
				status.spin === "stepped" && "animate-spin-stepped",
			)}
			aria-hidden
		/>
	);
	return (
		<span
			{...rest}
			ref={ref}
			// WHY role img: aria-label is ignored on a plain span.
			role="img"
			aria-label={status.phrase}
			className={clsx(
				"flex min-w-0 items-center gap-2 whitespace-nowrap text-sm font-semibold",
				syncStatusToneClassName[status.tone],
				className,
			)}
		>
			{iconPosition === "leading" && icon}
			{children}
			{iconPosition === "trailing" && icon}
		</span>
	);
};
